export default __webpack_public_path__ + "static/media/ENSIASWikiHub.b1396f56.jpg";